import { RequestHeader } from "../../request/request-header";
import { SignUpRequestBody } from "./sign-up-request-body";

export class SignUpRequest {
    header: RequestHeader;
    body: SignUpRequestBody;
}
